// (c) chaehongee. Confidential and proprietary.

import type { ReactElement } from 'react'
import styles from '../../Canvas.module.css'
import { UploadCloud, Loader2 } from 'lucide-react'

export function DropOverlay({ isDragOver, isUploading }: { isDragOver: boolean; isUploading: boolean }): ReactElement | null {
    if (!isDragOver && !isUploading) return null
    return (
        <div className={styles.dropOverlay} data-canvas-ui="true">
            <div className={styles.dropBox}>
                {isUploading ? (
                    <Loader2 className={styles.icon + ' ' + styles.spin} aria-hidden="true" />
                ) : (
                    <UploadCloud className={styles.icon} aria-hidden="true" />
                )}
                <span className={styles.dropText}>
                    {isUploading ? 'Uploading images…' : 'Drop images to upload'}
                </span>
            </div>
        </div>
    )
}

export default DropOverlay


